const StatusBadge = ({ status }) => {
  const styles =
    status === "published"
      ? "bg-green-100 text-green-700"
      : "bg-yellow-100 text-yellow-700";

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${styles}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full ${
          status === "published" ? "bg-green-500" : "bg-yellow-500"
        }`}
      />
      {status === "published" ? "Published" : "Draft"}
    </span>
  );
};

export default StatusBadge;
